module.exports = "images/culturebox.7a003248.png";